import { css, SerializedStyles } from '@emotion/react'
import { ExternalStyles, Text, TextProps, Theme, useTheme } from 'bold-ui'
import { FieldStatusEnum } from 'components/form'

interface TextStatusProps extends TextProps {
  status?: FieldStatusEnum
}

export const TextStatus = (props: TextStatusProps) => {
  const { status, style, children, ...rest } = props

  const theme = useTheme()
  const styles = createStyles(status, theme, style)

  return (
    <Text style={styles} {...rest}>
      {children}
    </Text>
  )
}

const createStyles = (status: FieldStatusEnum, theme: Theme, style: ExternalStyles): SerializedStyles => {
  if (status === FieldStatusEnum.REMOVIDO) {
    return css(
      css`
        text-decoration: line-through;
        color: ${theme.pallete.gray.c40};
      `,
      style
    )
  } else {
    return css(style)
  }
}
